import { useEffect, useRef, useState } from "react";

export function useInView(threshold = 0.1, startingVisible = false) {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(startingVisible);

  useEffect(() => {
    const node = ref.current;
    if (!node) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        setInView(entry.isIntersecting);
      },
      { threshold },
    );

    observer.observe(node);

    return () => {
      observer.unobserve(node);
    };
  }, [threshold]);

  return [ref, inView];
}
